import { Address } from '@domains/contacts';

export const extractCoordinates = ({ latitude, longitude }: Address): [number, number] | null =>
    latitude !== null && longitude !== null ? [latitude, longitude] : null;

export const formatRussianPhoneNumber = (phoneNumber: string) => {
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

    if (cleanedPhoneNumber.length !== 11) {
        throw new Error('Invalid phone number. Must be 11 digits long.');
    }

    const countryCode = '+7';
    const areaCode = cleanedPhoneNumber.substring(1, 4);
    const firstThreeDigits = cleanedPhoneNumber.substring(4, 7);
    const lastTwoDigits = cleanedPhoneNumber.substring(7, 9);
    const lastDigit = cleanedPhoneNumber.substring(9);

    return `${countryCode} (${areaCode}) ${firstThreeDigits}-${lastTwoDigits}-${lastDigit}`;
};

export const formatPlusSevenPhone = (value: string) => {
    if (/^[8]/.test(value)) {
        value = value.replace(/^[8]/g, '+7');
    }
    if (!/^[7]/.test(value) && value.length === 1) {
        value = `+7${value}`;
    }

    return `+${value}`;
};

export const contactPhone = '+7 (423) 224-48-03';
